// admin/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from './auth/AdminAuthContext';
import PrivateRoute from './auth/PrivateRoute';
import Login from './pages/Login';
import Home from './pages/Home';
import Programs from './pages/Programs';
import ResultContent from './pages/ResultContent';
import Sessions from './pages/Sessions';
import Analytics from './pages/Analytics';
import Questions from './pages/Questions';
import Branding from './pages/Branding';
import Deploy from './pages/Deploy';

export default function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/programs" element={<PrivateRoute><Programs /></PrivateRoute>} />
          <Route path="/questions" element={<PrivateRoute><Questions /></PrivateRoute>} />
          <Route path="/result-content" element={<PrivateRoute><ResultContent /></PrivateRoute>} />
          <Route path="/sessions" element={<PrivateRoute><Sessions /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
          <Route path="/branding" element={<PrivateRoute><Branding /></PrivateRoute>} />
          <Route path="/deploy" element={<PrivateRoute><Deploy /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AdminAuthProvider>
  );
}